import { useEffect, useRef, useState } from 'react';
import { ReactComponent as EnvelopeMailSvg } from '../../assets/svg/envelope-mail.svg';
import Dialog from './dialog';
import request from '../../lib/request';

const Message = ({ user, currentNav }) => {
  const dialogRef = useRef(null);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [message, setMessage] = useState({});

  useEffect(() => {
    getMessage({ next: false });
  }, [currentNav]);

  const getMessage = async ({ next = false }) => {
    try {
      let path = '/message';

      if (next) {
        const {
          total: { count, page, perPage },
        } = message;

        if (count < page * perPage) {
          return;
        }
        path += `?page=${page + 1}&perPage=${perPage}`;
      }

      const { result } = await request.get(path);

      if (result?.list) {
        setMessage((prev) => ({
          list: next ? prev.list?.concat(result.list) : result.list,
          unreadCount: result.unreadCount,
          unreadReplyCount: result.unreadReplyCount,
          total: result.total,
        }));
      }
    } catch (error) {
      console.error('Error fetching message:', error);
    }
  };

  const openDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
      setIsDialogOpen(true);
    }
  };

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
      setIsDialogOpen(false);
    }
  };

  return (
    <div className='absolute top-6 right-16'>
      {(message.unreadCount > 0 || message.unreadReplyCount > 0) && (
        <span className='absolute top-[-3px] right-[-4px]'>
          <span className='relative flex h-2 w-2'>
            <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75'></span>
            <span className='relative inline-flex rounded-full h-2 w-2 bg-red-500'></span>
          </span>
        </span>
      )}
      <EnvelopeMailSvg
        className='size-5 cursor-pointer'
        onClick={openDialog}
        fill='white'
      />
      <Dialog
        dialogRef={dialogRef}
        closeDialog={closeDialog}
        isDialogOpen={isDialogOpen}
        message={message}
        getMessage={getMessage}
        user={user}
      />
    </div>
  );
};

export default Message;
